import { Tooltip } from 'antd';
import { Icon } from '@docs/kd-d2c-components';
import { eed_mario_icon_reload_line } from '@src/assets/icons';
import './index.less';

export const RefreshButton = () => {
  return (
    <Tooltip title="刷新" placement="top">
      <span className="refresh-button" onClick={() => window.location.reload()}>
        <Icon
          icon={eed_mario_icon_reload_line}
          size={20}
          className="refresh-button-icon"
        />
      </span>
    </Tooltip>
  );
};
